export const BrandRibbonMock = {
  componentId: 'oweiyumjs33zf0l3',
  enableTracking: true,
  styleclass: 'color-scheme4',
  mainLogoPath: '/content/mi-luxury-spa/na/en-us/about-us',
  clickTrackValue: 'Brand Ribbon|luxury-Group|external',
  isAuthor: false,
  logoIcons: [
    {
      linkUrl: '/content/mi-luxury-spa/na/en-us/destinations/detail',
      icon: 'brand-logo-EB',
      linkText: 'EB',
      openInANewTab: true,
      clickTrackValue: 'Brand Ribbon|EB|external',
    },
    {
      linkUrl: '/content/mi-luxury-spa/na/en-us/experiences',
      icon: 'brand-logo-RZ',
      linkText: 'RZ',
      openInANewTab: false,
      clickTrackValue: 'Brand Ribbon|RZ|external',
    },
    {
      linkUrl: '/content/mi-luxury-spa/na/en-us/about-us/top-nav-cinemograph/cinemograph-image-var',
      icon: 'brand-logo-LC',
      linkText: 'LC',
      openInANewTab: true,
      clickTrackValue: 'Brand Ribbon|LC|external',
    },
    {
      linkUrl: 'https://luxurygrouphotels.com/',
      icon: 'brand-logo-XR',
      linkText: 'XR',
      openInANewTab: true,
      clickTrackValue: 'Brand Ribbon|XR|external',
    },
    {
      linkUrl: 'https://luxurygrouphotels.com/',
      icon: 'brand-logo-WH',
      linkText: 'WH',
      openInANewTab: false,
      clickTrackValue: 'Brand Ribbon|WH|external',
    },
    {
      linkUrl: 'https://luxurygrouphotels.com/',
      icon: 'brand-logo-JW',
      linkText: 'JW',
      openInANewTab: true,
      clickTrackValue: 'Brand Ribbon|JW|external',
    },
  ],
  ariaLabel: 'luxury-Group',
  path: '/content/mi-luxury-spa/na/en-us/home/jcr:content/root/responsivegrid/responsivegrid/brand_ribbon',
  ':type': 'mi-aem-luxury-spa/components/content/brand-ribbon/v1/brand-ribbon',
  location: 'Brand Ribbon',
  wcmMode: 'disabled',
  mainLogo: 'brand-logo-luxury-Group',
};
